import './global.css';
import './toastify.css';
import moment from 'moment';
import { useEffect } from 'react';
import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import LoginPage from './pages/authentication/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import LoadingPage from './pages/authentication/LoadingPage';
import { Routes, Route, useLocation } from "react-router-dom";
import { parseBouncer, apiPost, API_URL_AUTH } from './helpers/api.ts';
import ListBookingPage from './pages/users/list-booking/ListBookingPage';
import ManageBookingPage from './pages/users/manage-booking/ManageBookingPage';
import RequestBookingPage from './pages/users/request-booking/RequestBookingPage';
import { setLoading, updateToken, updateUser } from './reducers/authorization/actions';

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLoading = useSelector((state) => state.authentication.isLoading);
  const authorizedUser = useSelector((state) => state.authentication.authorizedUser);

  const authenticate = async () => {
    moment.locale('id');
    const bouncer = parseBouncer();
    if (bouncer.token) {
      try {
        dispatch(setLoading(true));
        const request = await apiPost(
          API_URL_AUTH.BY_TOKEN,
          bouncer.token
        );
        const response = await request.json();
        dispatch(updateUser(response.data));
        dispatch(updateToken(bouncer.token));
      } catch (error) {
        dispatch(updateUser(null));
        dispatch(updateToken(''));
      } finally {
        dispatch(setLoading(false));
      }
    }
  }

  useEffect(() => {
    authenticate();
  }, []);

  const renderLoginForm = () => {
    if (location.pathname === '/') return <div />;
    if (!authorizedUser) {
      return <LoginPage />;
    }
  }

  if (isLoading) return <LoadingPage />;

  return (
    <AppWrapper>
      <ToastContainer
        draggable
        rtl={false}
        closeOnClick
        pauseOnHover
        autoClose={3000}
        pauseOnFocusLoss
        newestOnTop={false}
        position="top-center"
        hideProgressBar={false}
      />
      { renderLoginForm() }
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/create-submission" element={<RequestBookingPage />} />
        <Route path="/submissions" element={<ListBookingPage />} />
        <Route path="/submissions/:id" element={<ManageBookingPage />} />
      </Routes>
    </AppWrapper>
  );
}

const AppWrapper = styled.div``;

export default App;